/**
 * Groups inconsistency issues by ruleId while preserving first-seen rule order.
 * @param {object[]} issues
 * @returns {{ ruleId: string, title: string, description: string|null, issues: object[] }[]}
 */
export const groupIssuesByRule = issues => {
    const groups = [];

    issues.forEach(issue => {
        let group = groups.find(({ ruleId }) => ruleId === issue.ruleId);

        if (!group) {
            group = {
                ruleId: issue.ruleId,
                title: issue.title || issue.ruleId,
                description: issue.description || null,
                issues: [],
            };
            groups.push(group);
        }

        group.issues.push(issue);
    });

    return groups;
};
